
import { GoogleSignin, statusCodes } from '@react-native-google-signin/google-signin';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { API } from './apis';
import i18n from 'i18next';

// Configure Google Sign-In
GoogleSignin.configure({
  webClientId: '767235889319-bquvrjmd54r3270to5dj7ttob0lt74ob.apps.googleusercontent.com',
  iosClientId: '767235889319-p3ck4q3od59f1jbi4r5e04a3sec0lp50.apps.googleusercontent.com',
});

  const checkCurrentUser = async () => {
    try {
      const isSignedIn = await GoogleSignin.isSignedIn();
      if (isSignedIn) {
        getCurrentUser();
      }
    } catch (error) {
      console.error('Check user error:', error);
    }
  };

  const getCurrentUser = async () => {
    try {
      const currentUser = GoogleSignin.getCurrentUser();
      console.log(currentUser);
    } catch (error) {
      console.error('Get current user error:', error);
    }
  };

  const signIn = async () => {
    try {
      await GoogleSignin.hasPlayServices();
      const userInfo = await GoogleSignin.signIn();
      let socialId, name, email;
      if (userInfo?.user) {
        socialId = userInfo.user.id;
        name = userInfo.user.name;
        email = userInfo.user.email;
      } else if (userInfo?.data?.user) {
        socialId = userInfo.data.user.id;
        name = userInfo.data.user.name;
        email = userInfo.data.user.email;
      } else {
        throw new Error('Unable to extract user information from Google Sign-In response');
      }

      const provider='google';
      const {data: resp} = await axios.post(API.SOCIAL_LOGIN_API, {
        provider,
        socialId: String(socialId),
        email,
        name
      }, {
        headers: {
          'Accept-Language': i18n.language === 'dt' ? 'du' : 'en',
        },
      });

      const payloadData = resp?.data ?? resp?.Data;
      const success = resp?.status === true || resp?.success === true || resp?.Success === true || Boolean(payloadData);
      const message = resp?.message || resp?.Message || 'Google login failed';
      if (!success || !payloadData) {
        throw new Error(message);
      }
      return payloadData;
      
    } catch (error) {
      console.log(error?.message || String(error));
      if (error.code === statusCodes.SIGN_IN_CANCELLED) {
        console.log('Sign in cancelled');
      } else if (error.code === statusCodes.IN_PROGRESS) {
        console.log('Sign in in progress');
      } else if (error.code === statusCodes.PLAY_SERVICES_NOT_AVAILABLE) {
        console.log('Play services not available');
      } else {
        console.error('Sign-in error:', error);
      }
      throw error;
    } finally {
      // no-op
    }
  };

  const signOut = async () => {
    try {
      await GoogleSignin.revokeAccess();
      await GoogleSignin.signOut();
      console.log('Sign out');
    } catch (error) {
      // Not signed in with Google (email or Apple login): nothing to end.
      console.log('Sign out:', error?.message);
    }
  };

export { signIn, signOut };